module.exports = __webpack_public_path__ + "img/P46-zh.993e13c7.png";